import { InfoTooltip } from "@/components/shared/info-tooltip";
import { Badge } from "@/components/ui/badge";

export const HolderBadge = () => (
  <InfoTooltip text="This Creator is a holder of your token.">
    <Badge className="text-xs" variant="outline">
      Holder
    </Badge>
  </InfoTooltip>
);
